import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalMessageService, GlobalMessageType, OccEndpointsService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { SharedService } from "src/app/shared/services/shared.service";
import { CustomCustomerServiceBrService } from "../custom-customer-service-br.service";

@Component({
  selector: 'app-ticket-details',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ticket-details.component.html',
  styleUrls: ['./ticket-details.component.scss'],
})
export class TicketDetailsComponent implements OnInit, OnDestroy {
  viewTicketSub: Subscription;
  ticketDetails: any;
  createdBy: any;
  ticketAttachments: any;
  uploadedFilesData = [];
  baseUrl: any;
  userId: any;
  ticketId: number;
  ticketHistory: any;
  updateTicketClicked=false;
  emailConsentChecked='false';
  ticketUpdate: Subscription;
  ticketUpdationErrorSub: Subscription;
  ticketUpdateForm = new FormGroup({
    ticketDesc: new FormControl('', [Validators.required]),
  });
  constructor(
    private readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    private readonly customerService: CustomCustomerServiceBrService,
    private readonly globalMessage: GlobalMessageService,
    private readonly sharedService: SharedService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.viewTicketSub = this.customerService.viewTicketDetails.subscribe(
      (res) => {
        if (res) {
          this.ticketDetails = res;
          this.ticketId= this.ticketDetails.id;
          const lastTicketEvent = this.ticketDetails?.ticketEvents[this.ticketDetails?.ticketEvents?.length-1];
          this.createdBy = lastTicketEvent?.author;
          this.ticketAttachments = lastTicketEvent?.attachments;
          this.ticketHistory = this.ticketDetails?.ticketEvents?.slice(0,-1);
        }
      }
    );
  }
  uploadFile(fileInput: any) {
    this.sharedService.fileChangeEvent(fileInput).subscribe((res: any) => {
      if (res) {
        this.uploadedFilesData.push(res);
      }
    });
  }
  removeUploadedFile(removedData) {
    this.uploadedFilesData = this.sharedService.removeFile(
      this.uploadedFilesData,
      removedData
    );
  }
  updateTicket():void{
    this.user.get().subscribe((res: any) => {
      if (res) {
        this.userId = res?.userName;
      }
    if(this.userId){
    this.updateTicketClicked=true;
    if(this.ticketUpdateForm?.valid){
      const params={
      description:this.ticketUpdateForm?.controls?.ticketDesc?.value,
      sendEmailConsent:this.emailConsentChecked,
      ticketAttachments:this.uploadedFilesData
    };
      this.customerService.updateTicketDetails(params,this.ticketId);
      this.ticketUpdate=this.customerService.ticketUpdationError.subscribe((res:any)=>{
        if(res){
          this.globalMessage.add(res,GlobalMessageType.MSG_TYPE_ERROR,5000000);
          this.modalService.dismissAll();
        }
      });
          this.modalService.dismissAll();
    }
  }
});
  }

  close(): void {
    this.modalService.dismissAll();
  }
  ngOnDestroy() {
    this.viewTicketSub?.unsubscribe();
  }
}
